<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "OidcCallback",
  methods: {
    ...mapActions(["oidcSignInCallback"])
  },
  mounted() {
    this.oidcSignInCallback()
      .then(redirectPath => {
        this.$router.push(redirectPath);
      })
      .catch(err => {
        if (err.message == "No matching state found in storage") {
          this.$router.push("/");
        } else {
          this.showError(
            "Je kan op dit moment niet ingelogd worden, probeer het later opnieuw",
            true,
            err
          );
        }
      });
  }
};
</script>
